export default __webpack_public_path__ + "static/media/IvyMode-Thin.41fe49fd.woff2";